// var data = require("../../data/NLA17_Condition_StatusChange_AllLakes_T2T3_2021_01_25_National.csv.json");
// exports.data = data;

// var riskData = require("../../data/NLA17_Risk_AllLakes_2021_01_25_National.csv.json");
// exports.riskData = riskData;

var hyphenData = require("../../data/hyphenation.csv.json");
exports.hyphenData = hyphenData;